import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import invoiceService from "services/invoiceService";

export const getInvoice = createAsyncThunk(
	"vino/invoice/fetch",
	async (id, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const invoice = await invoiceService.get(id);
			return invoice;
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting order",
					variant: "error",
				})
			);
			return rejectWithValue(e);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const invoiceSlice = createSlice({
	name: "vino/invoice",
	initialState: {
		data: null,
	},
	reducers: {
		resetInvoiceState: (state) => {
			state.data = null;
		},
		setInvoices: (state, action) => {
			state.data = action.payload;
		},
	},
	extraReducers: {
		[getInvoice.fulfilled]: (state, action) => {
			state.data = action.payload;
		},
	},
});

export const { resetInvoiceState } = invoiceSlice.actions;

export default invoiceSlice.reducer;
